'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEngagementsRate = exports.getPostTypes = undefined;

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _influencerReportCard = require('./../influencer-report-card');

var _influencerReportCard2 = _interopRequireDefault(_influencerReportCard);

var _reportHeader = require('./../report-header');

var _reportHeader2 = _interopRequireDefault(_reportHeader);

var _unavailableData = require('./../unavailable-data');

var _unavailableData2 = _interopRequireDefault(_unavailableData);

var _formatting = require('./../../utils/formatting');

var _colors = require('./../../utils/colors');

var _dyzioInstagramThumbnail = require('../../components/dyzio-instagram-thumbnail');

var _dyzioInstagramThumbnail2 = _interopRequireDefault(_dyzioInstagramThumbnail);

var _storyComponents = require('./components/story-components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DISPLAY_MIN = 10;

var paddingTop2em = {
  'padding-top': '2em'
};

var showButtonStyle = {
  color: _colors.dyzioPalette.pink
};

var avatarStyle = {
  width: 80,
  height: 80,
  float: 'left',
  margin: '0 0 0 0',
  backgroundColor: 'gray',
  display: 'inline-block'
};

var handleStyle = {
  padding: '15px 5px 5px 5px',
  marginLeft: 20,
  float: 'left',
  display: 'inline-block',
  fontSize: 16
};

var imageStyle = {
  height: 290,
  margin: '0 auto 20px auto',
  display: 'block',
  backgroundColor: 'transparent',
  objectFit: 'contain'
};

var segmentStyle = { marginTop: 10, marginBottom: 10 };

var captionStyle = { paddingTop: 10, color: 'black' };

var statsStyle = { paddingTop: 10, color: 'black', textAlign: 'left' };

var openURL = function openURL(url) {
  window.open(url, '_blank');
};

var getCampaignReportUrl = function getCampaignReportUrl() {
  var _window$location = window.location,
      origin = _window$location.origin,
      pathname = _window$location.pathname,
      search = _window$location.search;

  var newPath = _lodash2.default.replace(pathname, '-insights', '');
  console.log('' + origin + newPath + search);
  return '' + origin + newPath + search;
};

var getPostTypes = exports.getPostTypes = function getPostTypes(items) {
  var isStoryValidation = function isStoryValidation(post) {
    return _lodash2.default.eq('stories', _lodash2.default.get(post, 'type')) || _lodash2.default.eq('STORY', _lodash2.default.get(post, 'trackedAsset.assetType'));
  };
  var stories = _lodash2.default.filter(items, function (post) {
    return isStoryValidation(post);
  });
  var posts = _lodash2.default.reject(items, function (post) {
    return isStoryValidation(post);
  });
  return {
    stories: _lodash2.default.size(stories),
    posts: _lodash2.default.size(posts)
  };
};

var getEngagementsRate = exports.getEngagementsRate = function getEngagementsRate(_ref) {
  var likes = _ref.likes,
      comments = _ref.comments,
      posts = _ref.posts,
      followersCount = _ref.followersCount;
  return (likes + comments) / posts / followersCount * 100 || 0;
};

var InstagramStoryBlock = function InstagramStoryBlock(post) {
  // console.log(post);
  var followersCount = post.followersCount,
      attributes = post.attributes,
      insights = post.insights,
      handle = post.handle,
      profilePic = post.profilePic;

  var _ref2 = attributes || {},
      latestImpressions = _ref2.latestImpressions,
      latestReach = _ref2.latestReach,
      publishedDate = _ref2.publishedDate;

  var _ref3 = insights || {},
      impressions = _ref3.impressions,
      reach = _ref3.reach;

  return _react2.default.createElement(
    _semanticUiReact.Card,
    { fluid: true, style: segmentStyle, color: 'blue' },
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      { textAlign: 'center' },
      _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { columns: 2 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_storyComponents.StoryImageModalComponent, { story: post })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_semanticUiReact.Image, {
              src: profilePic,
              className: 'circular',
              size: 'tiny',
              style: avatarStyle
            }),
            _react2.default.createElement(
              'div',
              { style: handleStyle },
              _react2.default.createElement(
                'b',
                null,
                _lodash2.default.truncate(handle, {
                  length: 15
                })
              ),
              _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
              (0, _formatting.commaFormatted)(followersCount || 0),
              ' followers'
            ),
            _react2.default.createElement(
              _semanticUiReact.Label,
              { color: 'pink' },
              'Instagram STORY'
            ),
            _react2.default.createElement(
              'p',
              { style: statsStyle },
              'Reach: ',
              (0, _formatting.commaFormatted)(reach || latestReach)
            ),
            _react2.default.createElement(
              'p',
              { style: statsStyle },
              'Impressions: ',
              (0, _formatting.commaFormatted)(impressions || latestImpressions)
            ),
            _react2.default.createElement(_semanticUiReact.Divider, null),
            _react2.default.createElement(
              'p',
              { style: statsStyle },
              _lodash2.default.head(_lodash2.default.split(publishedDate, 'T'))
            )
          )
        )
      )
    )
  );
};

var getInstagramPostType = function getInstagramPostType(post) {
  var isIGTV = post.isIGTV,
      isReel = post.isReel,
      isCarousel = post.isCarousel,
      isVideo = post.isVideo,
      viewCount = post.viewCount,
      playCount = post.playCount;

  if (isIGTV) return 'IGTV';
  if (isReel) return 'REEL';
  if (isCarousel) return 'CAROUSEL';
  if (isVideo) return 'VIDEO';
  if (!_lodash2.default.isNull(viewCount) && !_lodash2.default.isNull(playCount)) return 'VIDEO';
  return 'IMAGE';
};

var InstagramPostBlock = function InstagramPostBlock(post) {
  var engagementsRate = post.engagementsRate,
      profilePic = post.profilePic,
      handle = post.handle,
      followersCount = post.followersCount,
      commentCount = post.commentCount,
      likeCount = post.likeCount,
      viewCount = post.viewCount,
      playCount = post.playCount,
      trackedAsset = post.trackedAsset,
      reach = post.reach,
      impressions = post.impressions;
  var publishedDate = trackedAsset.publishedDate,
      id = trackedAsset.id;

  return _react2.default.createElement(
    _semanticUiReact.Card,
    { fluid: true, style: segmentStyle, onClick: function onClick() {
        return openURL(_lodash2.default.get(post, 'trackedAsset.assetURL'));
      }, color: 'blue' },
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      { textAlign: 'center' },
      _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { columns: 2 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_dyzioInstagramThumbnail2.default, {
              customStyle: imageStyle,
              assetId: _lodash2.default.get(post, 'instagramId'),
              fallbackURL: _lodash2.default.get(post, 'thumbnail'),
              trackedAssetId: id
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_semanticUiReact.Image, {
              src: profilePic,
              className: 'circular',
              size: 'tiny',
              style: avatarStyle
            }),
            _react2.default.createElement(
              'div',
              { style: handleStyle },
              _react2.default.createElement(
                'b',
                null,
                _lodash2.default.truncate(handle, {
                  length: 15
                })
              ),
              _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
              (0, _formatting.commaFormatted)(followersCount || 0),
              ' followers'
            ),
            _react2.default.createElement(
              _semanticUiReact.Label,
              { color: 'pink' },
              'Instagram ',
              getInstagramPostType(post)
            ),
            _react2.default.createElement(
              'p',
              { style: statsStyle },
              'Likes: ',
              (0, _formatting.commaFormatted)(likeCount)
            ),
            _react2.default.createElement(
              'p',
              { style: statsStyle },
              'Comments: ',
              (0, _formatting.commaFormatted)(commentCount)
            ),
            _react2.default.createElement(
              'p',
              { style: statsStyle },
              'Views: ',
              (0, _formatting.commaFormatted)(viewCount || playCount)
            ),
            _react2.default.createElement(
              'p',
              { style: statsStyle },
              'Engagement rate: ',
              (0, _formatting.percentFormatted)(engagementsRate),
              '%'
            ),
            _react2.default.createElement(
              'p',
              { style: statsStyle },
              'Reach: ',
              (0, _formatting.commaFormatted)(reach)
            ),
            _react2.default.createElement(
              'p',
              { style: statsStyle },
              'Impressions: ',
              (0, _formatting.commaFormatted)(impressions)
            ),
            _react2.default.createElement(_semanticUiReact.Divider, null),
            _react2.default.createElement(
              'p',
              { style: statsStyle },
              _lodash2.default.head(_lodash2.default.split(publishedDate, 'T'))
            )
          )
        )
      )
    )
  );
};

var EmptyDataComponent = function EmptyDataComponent() {
  return _react2.default.createElement(_unavailableData2.default, { iconName: 'circle thin', iconColor: 'grey', content: 'This channel does not support this data.' });
};
var isStory = function isStory(post) {
  return _lodash2.default.get(post, 'type') === 'stories' || _lodash2.default.get(post, 'trackedAsset.assetType') === 'STORY';
};

var CampaignInsightsReport = function (_React$Component) {
  (0, _inherits3.default)(CampaignInsightsReport, _React$Component);

  function CampaignInsightsReport() {
    (0, _classCallCheck3.default)(this, CampaignInsightsReport);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CampaignInsightsReport.__proto__ || (0, _getPrototypeOf2.default)(CampaignInsightsReport)).call(this));

    _this.componentDidMount = function () {
      var withHeader = _this.props.withHeader;

      _this.setState({
        withHeader: withHeader
      });
    };

    _this.onSortChanged = function (event, _ref4) {
      var value = _ref4.value,
          text = _ref4.text;

      _this.setState({
        sort: value,
        activeSort: text
      });
    };

    _this.onPostSortChanged = function (event, _ref5) {
      var value = _ref5.value,
          text = _ref5.text;

      _this.setState({
        postSort: value,
        activePostSort: text
      });
    };

    _this.onStoriesSortChanged = function (event, _ref6) {
      var value = _ref6.value,
          text = _ref6.text;

      _this.setState({
        storySort: value,
        activeStorySort: text
      });
    };

    _this.sortedPosts = function (posts, sort) {
      var _this$state = _this.state,
          displayIGPosts = _this$state.displayIGPosts,
          postsUniqByInf = _this$state.postsUniqByInf;

      var sortedPosts = _lodash2.default.orderBy(posts, sort, 'desc');
      if (postsUniqByInf) {
        sortedPosts = _lodash2.default.uniqBy(sortedPosts, 'handle');
      }
      return _lodash2.default.take(sortedPosts, displayIGPosts);
    };

    _this.sortedStories = function (stories, sort) {
      var _this$state2 = _this.state,
          displayIGStories = _this$state2.displayIGStories,
          storiesUniqByInf = _this$state2.storiesUniqByInf;


      var insightsStories = _lodash2.default.map(stories, function (s) {
        _lodash2.default.assignIn(s, { sort: _lodash2.default.get(s, 'insights.' + sort) || _lodash2.default.get(s, 'trackedAsset.insights.' + sort) || 0 });
        return s;
      });

      var sortedStories = _lodash2.default.orderBy(insightsStories, 'sort', 'desc');

      if (storiesUniqByInf) {
        sortedStories = _lodash2.default.uniqBy(sortedStories, 'handle');
      }

      console.log(sortedStories);

      return _lodash2.default.take(sortedStories, displayIGStories);
    };

    _this.state = {
      sort: 'values.totals.engagementsRate',
      postSort: 'engagementsRate',
      storySort: 'reach',
      activeSort: 'engagements rate',
      activePostSort: 'engagements rate',
      activeStorySort: 'reach',
      displayInfluencers: DISPLAY_MIN,
      displayIGPosts: DISPLAY_MIN,
      displayIGStories: DISPLAY_MIN,
      postsUniqByInf: false,
      storiesUniqByInf: false
    };
    return _this;
  }

  (0, _createClass3.default)(CampaignInsightsReport, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$data$data = this.props.data.data,
          name = _props$data$data.name,
          createdBy = _props$data$data.createdBy,
          liveDate = _props$data$data.liveDate,
          endDate = _props$data$data.endDate,
          posts = _props$data$data.posts;
      var _state = this.state,
          sort = _state.sort,
          withHeader = _state.withHeader,
          postSort = _state.postSort,
          storySort = _state.storySort,
          activeSort = _state.activeSort,
          activePostSort = _state.activePostSort,
          activeStorySort = _state.activeStorySort,
          displayIGPosts = _state.displayIGPosts,
          displayInfluencers = _state.displayInfluencers,
          displayIGStories = _state.displayIGStories,
          postsUniqByInf = _state.postsUniqByInf,
          storiesUniqByInf = _state.storiesUniqByInf;


      console.log(sort);
      console.log(postSort);

      var allPosts = _lodash2.default.compact(_lodash2.default.reduce(posts, function (result, item) {
        var list = [];
        _lodash2.default.assignIn(item.totals, getPostTypes(item.posts));
        _lodash2.default.assignIn(item.totals, {
          engagementsRate: getEngagementsRate(item.totals)
        });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(item.posts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var post = _step.value;

            post.profilePic = _lodash2.default.get(item, 'profilePic');

            var _$get = _lodash2.default.get(item, 'totals'),
                followersCount = _$get.followersCount;

            var commentCount = post.commentCount,
                likeCount = post.likeCount,
                insights = post.insights;

            post.followersCount = followersCount;
            post.reach = _lodash2.default.get(insights, 'reach');
            post.impressions = _lodash2.default.get(insights, 'impressions');
            post.numberOfPosts = item.posts.length;
            post.engagementsRate = 100 * ((commentCount + likeCount) / followersCount);
            list.push(post);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        result.push(list);
        return result;
      }, []));

      var igPosts = [];
      var igStories = [];

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(allPosts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var p = _step2.value;

          igPosts = _lodash2.default.concat(igPosts, p);
          igStories = _lodash2.default.concat(igStories, p);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      igPosts = _lodash2.default.reject(igPosts, function (p) {
        return isStory(p);
      });
      igStories = _lodash2.default.filter(igStories, function (p) {
        return isStory(p);
      });

      console.log('igPosts', igPosts);
      console.log('igStories', igStories);

      var items = _lodash2.default.map(posts, function (values, handle) {
        var position = _lodash2.default.keys(posts).indexOf(handle);
        return { handle: handle, values: values, colors: (0, _colors.getRowColors)(position) };
      });

      console.log('items', items);

      var influencersOptions = [{
        onClick: this.onSortChanged,
        key: 'engagementsRate',
        active: sort === 'values.totals.engagementsRate',
        value: 'values.totals.engagementsRate',
        text: 'engagements rate',
        icon: 'percent'
      }, {
        onClick: this.onSortChanged,
        key: 'likes',
        active: sort === 'values.totals.likes',
        value: 'values.totals.likes',
        text: 'likes',
        icon: 'empty heart'
      }, {
        onClick: this.onSortChanged,
        key: 'comments',
        active: sort === 'values.totals.comments',
        value: 'values.totals.comments',
        text: 'comments',
        icon: 'comments outline'
      }, {
        onClick: this.onSortChanged,
        key: 'views',
        active: sort === 'values.totals.views',
        value: 'values.totals.views',
        text: 'views',
        icon: 'video play'
      }, {
        onClick: this.onSortChanged,
        key: 'reach',
        active: sort === 'values.totals.reach',
        value: 'values.totals.reach',
        text: 'reach',
        icon: 'bullhorn'
      }, {
        onClick: this.onSortChanged,
        key: 'impressions',
        active: sort === 'values.totals.impressions',
        value: 'values.totals.impressions',
        text: 'impressions',
        icon: 'eye'
      }, {
        onClick: this.onSortChanged,
        key: 'posts',
        active: sort === 'values.totals.posts',
        value: 'values.totals.posts',
        text: 'posts',
        icon: 'instagram'
      }, {
        onClick: this.onSortChanged,
        key: 'stories',
        active: sort === 'values.totals.stories',
        value: 'values.totals.stories',
        text: 'stories',
        icon: 'instagram'
      }];

      var igPostOptions = [{
        onClick: this.onPostSortChanged,
        key: 'engagementsRate',
        active: postSort === 'engagementsRate',
        value: 'engagementsRate',
        text: 'engagements rate',
        icon: 'percent'
      }, {
        onClick: this.onPostSortChanged,
        key: 'likes',
        active: postSort === 'like',
        value: 'likeCount',
        text: 'likes',
        icon: 'empty heart'
      }, {
        onClick: this.onPostSortChanged,
        key: 'comments',
        active: postSort === 'comment',
        value: 'commentCount',
        text: 'comments',
        icon: 'comments outline'
      }, {
        onClick: this.onPostSortChanged,
        key: 'reach',
        active: postSort === 'reach',
        value: 'reach',
        text: 'reach',
        icon: 'line graph'
      }, {
        onClick: this.onPostSortChanged,
        key: 'impressions',
        active: postSort === 'impressions',
        value: 'impressions',
        text: 'impressions',
        icon: 'eye'
      }];

      var igStoryOptions = [{
        onClick: this.onStoriesSortChanged,
        key: 'reach',
        active: activeStorySort === 'reach',
        value: 'reach',
        text: 'reach',
        icon: 'line graph'
      }, {
        onClick: this.onStoriesSortChanged,
        key: 'impressions',
        active: activeStorySort === 'impressions',
        value: 'impressions',
        text: 'impressions',
        icon: 'eye'
      }];

      var isEmptyCampaign = _lodash2.default.size(posts) === 0;

      var headerInfo = {
        hasLogo: false,
        campaignName: name,
        reportDate: liveDate,
        reportType: 'Instagram',
        liveDate: liveDate,
        endDate: endDate
      };

      return _react2.default.createElement(
        'div',
        null,
        isEmptyCampaign && _react2.default.createElement(
          _semanticUiReact.Message,
          { icon: 'icon', warning: 'warning' },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning' }),
          _react2.default.createElement(
            _semanticUiReact.Message.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Message.Header,
              null,
              'Warning'
            ),
            'No posts included in this campaign'
          )
        ),
        !isEmptyCampaign && withHeader && _react2.default.createElement(
          _semanticUiReact.Card,
          { fluid: 'fluid', color: 'pink' },
          _react2.default.createElement(
            _semanticUiReact.Card.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Message,
              { icon: 'icon' },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'file text outline', color: 'pink' }),
              _react2.default.createElement(
                _semanticUiReact.Message.Content,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Message.Header,
                  null,
                  name
                ),
                'created by ',
                createdBy
              )
            ),
            _react2.default.createElement(_reportHeader2.default, { info: headerInfo })
          )
        ),
        !isEmptyCampaign && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 4 },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Top ',
                  displayInfluencers,
                  ' Influencers'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 4 },
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  text: activeSort,
                  selection: true,
                  options: influencersOptions
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Card.Group,
            { itemsPerRow: 4 },
            _lodash2.default.map(_lodash2.default.take(_lodash2.default.orderBy(items, sort, 'desc'), displayInfluencers), function (value, idx) {
              return _react2.default.createElement(_influencerReportCard2.default, { value: value, key: idx });
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 4 },
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    onClick: function onClick() {
                      return openURL(getCampaignReportUrl());
                    },
                    style: showButtonStyle
                  },
                  'View all'
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 4 },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Top ',
                  displayIGPosts,
                  ' Posts'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 4 },
                _react2.default.createElement(_semanticUiReact.Checkbox, {
                  toggle: true,
                  label: 'Unique by influencer',
                  checked: postsUniqByInf,
                  onClick: function onClick() {
                    _this2.setState({
                      postsUniqByInf: !postsUniqByInf
                    });
                  }
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 4 },
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  text: activePostSort,
                  selection: true,
                  options: igPostOptions
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Card.Group,
              { itemsPerRow: 2 },
              _lodash2.default.map(this.sortedPosts(igPosts, postSort), function (post) {
                return InstagramPostBlock(post);
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { style: paddingTop2em },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 4 },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Top ',
                  displayIGStories,
                  ' Stories'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 4 },
                _react2.default.createElement(_semanticUiReact.Checkbox, {
                  toggle: true,
                  label: 'Unique by influencer',
                  checked: storiesUniqByInf,
                  onClick: function onClick() {
                    _this2.setState({
                      storiesUniqByInf: !storiesUniqByInf
                    });
                  }
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 4 },
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  text: activeStorySort,
                  selection: true,
                  options: igStoryOptions
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Card.Group,
              { itemsPerRow: 2 },
              _lodash2.default.map(this.sortedStories(igStories, storySort), function (story) {
                return InstagramStoryBlock(story);
              })
            )
          )
        )
      );
    }
  }]);
  return CampaignInsightsReport;
}(_react2.default.Component);

CampaignInsightsReport.propTypes = {
  data: _propTypes2.default.object.isRequired,
  withHeader: _propTypes2.default.bool.isRequired
};

CampaignInsightsReport.defaultProps = {
  withHeader: false
};

exports.default = CampaignInsightsReport;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/campaign-insights-report/index.js
// module id = 2205
// module chunks = 1